import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import CopilotPanel from "./CopilotPanel";

export default function AppLayout() {
  const [copilotOpen, setCopilotOpen] = useState(() => localStorage.getItem("fg_copilot") === "1");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleCopilot = () => {
    setCopilotOpen((v) => {
      localStorage.setItem("fg_copilot", v ? "0" : "1");
      return !v;
    });
  };
  // pages (e.g. Drawing Studio) can ask to open/close the copilot drawer
  useEffect(() => {
    const open = () => setCopilotOpen((v) => {
      if (!v) localStorage.setItem("fg_copilot", "1");
      return true;
    });
    const close = () => setCopilotOpen((v) => {
      if (v) localStorage.setItem("fg_copilot", "0");
      return false;
    });
    window.addEventListener("fg:copilot-open", open);
    window.addEventListener("fg:copilot-close", close);
    return () => {
      window.removeEventListener("fg:copilot-open", open);
      window.removeEventListener("fg:copilot-close", close);
    };
  }, []);
  return (
    <div className="h-screen bg-[var(--c-bg)] flex overflow-hidden" data-testid="app-layout">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex-1 flex flex-col min-w-0">
        <Header copilotOpen={copilotOpen} onToggleCopilot={toggleCopilot}
          onToggleSidebar={() => setSidebarOpen((v) => !v)} />
        <main className="flex-1 overflow-y-auto" data-testid="main-content">
          <Outlet />
        </main>
      </div>
      <CopilotPanel open={copilotOpen} onClose={toggleCopilot} />
    </div>
  );
}
